import { Component, Inject } from '@angular/core';
import { ScheduleMeetingDialogComponent } from '../schedule-meeting-dialog/schedule-meeting-dialog-component';
import { MatDialog } from '@angular/material/dialog';
import { MEETING_SETTINGS_LIST_VIEW_PAGE_TOKEN } from '../../../data-providers/providers';
import { Observable } from 'rxjs';

@Component({
  selector: 'meeting-scheduler-my-meetings-actions',
  templateUrl: './schedule-my-meetings-actions.component.html',
  styleUrls: ['./schedule-my-meetings-actions.component.scss'],
  standalone: false,
})
export class ScheduleMyMeetingsActionsComponent {
  constructor(
    private readonly dialog: MatDialog,
    @Inject(MEETING_SETTINGS_LIST_VIEW_PAGE_TOKEN) readonly meetingSettingsListViewPage$: Observable<string>,
  ) {
  }

  openScheduleMeetingDialog() {
    this.dialog.open(ScheduleMeetingDialogComponent, { width: '550px' });
  }
}
